var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display3d"},[_c('div',{attrs:{"id":"map"}}),_c('share-reason',{attrs:{"shareReason":_vm.shareReason}}),_c('TopShareBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }